export type ErrorMarker<Name extends string> = `$$${Name}$$`;
export const createErrorMarker = <T extends string>(errorName: T): ErrorMarker<T> => `$$${errorName}$$`;
